import * as React from 'react';
import BuyersPremium from '@/components/BuyersPremium/BuyersPremium';
import DescriptionSection from './DescriptionSection';
import { FormattedMessage } from 'react-intl';
import { getCatalog } from '@/redux/modules/catalog';
import { getItem } from '@/redux/modules/item';
import { getItemDetail } from '@/redux/modules/itemDetail';
import isEqual from 'react-fast-compare';
import { safelyRender } from '@/utils/safelyRender';
import styled from 'styled-components';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import { useSelector } from 'react-redux';

const FIVE_YEARS_AGO = (Date.now() - 1.577e11) / 1000; // 5 YEARS!

type Props = {
    className?: string;
    itemId: number;
};

function ItemDescription({ className = '', itemId }: Props) {
    const { catalogId, lotNumber } = useSelector((state) => getItem(state, itemId), isEqual);
    const { conditionReport = '', description = '', dimensions = '', weight = '' } = useSelector((state) =>
        getItemDetail(state, itemId)
    );
    const { saleStartTs } = useSelector((state) => getCatalog(state, catalogId), isEqual);

    const showDimensions = dimensions.trim() !== '';
    const showWeight = weight.trim() !== '';

    const old = saleStartTs < FIVE_YEARS_AGO;

    return (
        <StyledItemDescription className={className}>
            <StyledH3 h3>
                <FormattedMessage id="lot_details" values={{ lotNumber }} />
            </StyledH3>
            <DescriptionSection body={safelyRender(description, 'div', old)} header="description" />
            {conditionReport && <DescriptionSection body={safelyRender(conditionReport, 'div')} header="condition" />}
            {showDimensions && <DescriptionSection body={safelyRender(dimensions, 'div')} header="dimensions" />}
            {showWeight && <DescriptionSection body={safelyRender(weight, 'div')} header="weight" />}
            <BuyersPremium catalogId={catalogId} />
        </StyledItemDescription>
    );
}

export default React.memo<Props>(ItemDescription, isEqual);

const StyledItemDescription = styled.div`
    margin-top: 40px;

    @media print {
        display: flex;
        flex-direction: column;
        > * {
            max-width: 400px;
            margin: 12px auto;
        }
    }
`;

const StyledH3 = styled(Text)`
    background-color: ${({ theme }) => theme.colors.white};
    display: block;
    margin: 0 0 40px;
    margin-top: 10px;
    padding-bottom: 10px;
    color: ${({ theme }) => theme.colors.black};
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey400};

    @media (max-width: 500px) {
        margin-top: 0;
    }
`;
